import * as React from 'react';

import { requestPost } from '../../../../modules/request/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'
import { Checkbox, } from '../../../Shared/index'

interface TransferOwnershipModalProps {
  classroom: any;
  close: () => void;
  coteacher: any;
  onSuccess: (message: string) => void;
}

const TransferOwnershipModal: React.FC<TransferOwnershipModalProps> = ({ classroom, close, coteacher, onSuccess }) => {
  const { modalRef, } = useModalAccessibility(close)

  const [checkboxAcknowledged, setCheckboxAcknowledged] = React.useState<boolean>(false);

  const transferOwnership = () => {
    requestPost(
      `/teachers/classrooms/${classroom.id}/transfer_ownership`,
      { requested_new_owner_id: coteacher.id },
      (body: any) => {
        onSuccess('Class transferred');
        close();
      }
    );
  };

  const submitButtonClass = (): string => {
    let buttonClass = 'quill-button contained green medium focus-on-light';
    if (!checkboxAcknowledged) {
      buttonClass += ' disabled';
    }
    return buttonClass;
  };

  const toggleCheckbox = () => {
    setCheckboxAcknowledged((prev) => !prev);
  };

  const renderCheckboxes = () => (
    <div className="checkboxes">
      <div className="checkbox-row">
        <Checkbox
          label="I understand that I will no longer have the ability to archive classes or edit activity packs."
          onClick={toggleCheckbox}
          selected={checkboxAcknowledged}
        />
      </div>
    </div>
  );

  return (
    <div className="modal-container transfer-ownership-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="transferOwnershipModalTitle"
        aria-modal="true"
        className="transfer-ownership-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="transferOwnershipModalTitle">
            Transfer ownership of this class?
          </h3>
        </div>
        <p>
          You are transferring the class {classroom.name} to {coteacher.name} ({coteacher.email}). You will still have access to the class as a co-teacher.
        </p>
        {renderCheckboxes()}
        <div className="form-buttons">
          <button
            className="quill-button outlined grey medium focus-on-light"
            onClick={close}
            type="button"
          >
            Cancel
          </button>
          <button
            className={submitButtonClass()}
            onClick={transferOwnership}
            type="button"
          >
            Transfer class
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransferOwnershipModal;
